import { useRef, useState } from 'react';
import { applyPattern } from '../../utils';
import { useRunAfterUpdate } from '../useRunAfterUpdate';
const NO_VALUE = '';
function useMaskInput({ initialValue = NO_VALUE, mask, onChange = () => {
    // does nothing
}, ...rest }) {
    const inputRef = useRef(null);
    const [value, setValue] = useState(initialValue);
    const runAfterUpdate = useRunAfterUpdate();
    function handleInputChange(evt) {
        const input = inputRef.current;
        const [formattedText, newCursor] = applyPattern({
            text: evt.target.value,
            pattern: mask,
            cursor: evt.target.selectionStart || 0
        });
        if (formattedText !== undefined) {
            setValue(formattedText);
            runAfterUpdate(() => {
                if (!input) {
                    return;
                }
                input.selectionStart = newCursor;
                input.selectionEnd = newCursor;
            });
            const newEvent = createUserEvent(evt, formattedText);
            onChange === null || onChange === void 0 ? void 0 : onChange(newEvent);
        }
    }
    return {
        inputProps: {
            onChange: handleInputChange,
            value,
            ref: inputRef,
            maxLength: mask ? mask.length : undefined,
            ...rest
        }
    };
}
function createUserEvent(origEvent, newValue) {
    return {
        ...origEvent,
        target: {
            ...origEvent.target,
            value: newValue
        },
        currentTarget: {
            ...origEvent.currentTarget,
            value: newValue
        }
    };
}
export { useMaskInput };
//# sourceMappingURL=useMaskInput.js.map